import { NavLink } from "react-router-dom";
import { Home, Plus, Calendar, User } from "lucide-react";
import { cn } from "@/lib/utils";

interface BottomTabBarProps {
  brandColor?: string | null;
}

const tabs = [
  { to: "/app", label: "Home", icon: Home, end: true },
  { to: "/app/book", label: "Book", icon: Plus, end: false },
  { to: "/app/bookings", label: "Bookings", icon: Calendar, end: false },
  { to: "/app/profile", label: "Profile", icon: User, end: false },
];

const BottomTabBar = ({ brandColor }: BottomTabBarProps) => {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-4">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center gap-1 py-3 text-xs font-medium transition-colors",
                  isActive
                    ? "text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                )
              }
              style={({ isActive }) =>
                isActive && brandColor ? { color: brandColor } : undefined
              }
            >
              <Icon className="h-5 w-5" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomTabBar;
